import { useState } from 'react'
import React from 'react'
import { setCredentials } from '../../app/slices/authSlice'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import logo from "../../assets/onnize.png"
import "./user.css"
import { toast } from 'react-toastify'
import { api } from '../../app/Api/ApiSlice'

const Login = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [isLoading,setIsLoading] = useState(false)


    const handleSubmit = async (e) => {
        e.preventDefault()

      const userDetails = {email,password}

        try {
            setIsLoading(true)
            const response = await api.post("/account/login",userDetails)
            if(response){
                setIsLoading(false)
                dispatch(setCredentials(response?.data))
                navigate('/')
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response?.data?.message ||"Error,could not login")
            console.log(error)
        }

    }

    return (
        <div className="page">
            <div className='login userform'>
                <div className="onnize-logo">
                    <img src={logo} alt="onnize" />
                </div>
                <form className="">
                    <h1 className="form-header">Login</h1>
                    <div className="form-input">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id='email'
                            placeholder='email'
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-input">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id='password'
                            placeholder='password'
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-btn">
                        <button
                            type='submit'
                            className="signup-btn form-btn"
                            onClick={handleSubmit}
                        >{isLoading ? "Loading" : "Login"}
                        </button>
                    </div>
                </form>
                <div className="change-form">
                    <p>Don't have an account?</p><Link to="/signup" className='form-link'>Signup</Link>
                </div>
                <div className="change-form">
                    <p>Forgot password? </p><Link to="/forgot-password" className='form-link'>Set new</Link>
                </div>


            </div>
        </div>
    )
}

export default Login